import { createRoute } from '@tanstack/react-router';
import { LeasingList, type LeasingTab } from '@/modules/leasing/LeasingList';
import { Route as RootRoute } from './__root';

interface LeasingSearch {
  tab?: LeasingTab;
  name?: string;
  cislo?: string;
  vin?: string;
  spz?: string;
}

const TAB_VALUES = ['smlouvy', 'nabidky', 'search'] as const;

function parseLeasingSearch(input: Record<string, unknown>): LeasingSearch {
  const out: LeasingSearch = {};
  const t = input.tab;
  if (typeof t === 'string' && (TAB_VALUES as readonly string[]).includes(t)) {
    out.tab = t as LeasingTab;
  }
  for (const key of ['name', 'cislo', 'vin', 'spz'] as const) {
    const v = input[key];
    if (typeof v === 'string' && v.length > 0) out[key] = v;
  }
  return out;
}

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/leasing',
  component: LeasingList,
  validateSearch: parseLeasingSearch,
});
